import React, { useEffect, useRef, useState } from 'react';
import { EMAIL, socials } from '../data';
import Arrow from '../components/Arrow';
import './Contact.css';

async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // The clipboard API only exists on https and localhost
    const area = document.createElement('textarea');
    area.value = text;
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    area.remove();
    return ok;
  }
}

const phrases = ['Say hello', 'Got an idea? Let’s build it'];

export default function Contact() {
  const [copied, setCopied] = useState(false);
  const timer = useRef();
  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = async () => {
    if (!(await copyText(EMAIL))) return;
    setCopied(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), 1800);
  };


  return (
    <main className="contact">
      <div className="shell">
        <div className="meta-row fade-in">
          <span className="meta">Get in touch</span>
          <span className="meta"><i className="dot" />Available for work</span>
        </div>

        <h1 className="display contact-title">
          <span className="mask"><span>Contact</span></span>
        </h1>

        <p className="contact-lead fade-in" style={{ '--d': 1 }}>
          Got a question, a proposal, or something you want built? Tell me what you are working on and I'll come back to you.
        </p>
      </div>

      <div className="contact-band fade-in" style={{ '--d': 2 }} aria-hidden="true">
        <div className="contact-track">
          {[...phrases, ...phrases].map((p, i) => (
            <span key={i} className="display">{p}<i>–</i></span>
          ))}
        </div>
      </div>

      <div className="shell">
        <p className="meta contact-label rv">Write to me</p>
        <div className="contact-mail rv">
          <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
          <button type="button" className="meta" onClick={copy}>
            <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="1.5" /><path d="M16 8V5.5A1.5 1.5 0 0 0 14.5 4h-9A1.5 1.5 0 0 0 4 5.5v9A1.5 1.5 0 0 0 5.5 16H8" /></svg>
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>

        <p className="meta contact-label contact-else rv">Elsewhere</p>
        <ul className="contact-list">
          {socials.map(s => (
            <li key={s.label} className="rv">
              <a href={s.url} target="_blank" rel="noreferrer">
                <span className="contact-name">{s.label.replace(' / Twitter', '')}</span>
                <span className="meta">{s.handle}</span>
                <Arrow />
              </a>
            </li>
          ))}
        </ul>

        <footer className="contact-foot meta">
          <span>© {new Date().getFullYear()} Temitope Abodunrin</span>
          <span>All rights reserved</span>
        </footer>
      </div>
    </main>
  );
}
